import { TaskModel } from '@bryntum/gantt';
import {
  compareWBS,
} from "../ganttUtils";

export default class GanttTask extends TaskModel {
  static get fields() {
    return [
      { name: "ERPWbs", compare: compareWBS, type: 'string' },
      { name: "earlyEndDate", persist: true },
      { name: "earlyStartDate", persist: true },
      { name: "lateEndDate", persist: true },
      { name: "lateStartDate", persist: true },
      { name: "projectColor", persist: false, type: 'string' }, 
      { name: "cls", persist: false }, 
      { name: "duration", persist: false },
      { name: "calendar", persist: false },
      { name: "direction", persist: false }, 
      { name: "inactive", persist: false }, 
      { name: "RidderType", type: 'string' },
      { name: "OrderNumber", type: 'string' },
      { name: "PlanLevel", type: 'string' },
      { name: "DepartmentDescription", type: 'string' },
      { name: "WorkActivityDescription", type: 'string' },
      { name: "WorkActivityGroupDescription", type: 'string' },
      { name: "projectNumber", type: 'string' },
      { name: "CustomerName", type: 'string' },
      { name: "taskBarColor", type: 'string' },
      { name: "LastSyncMessage", type: 'string' },
      { name: "LastSyncMessageType", type: 'string' },
      { name: "assignments", type: 'string' },
      { name: "description", type: 'string' },
      { name: "prefix", type: 'string' },
      { name: "segmentSeqNr", type: 'integer', persist: true },
      { name: "SplitFromID", type: 'string', persist: true },      
      { name: "isSplit", type: 'boolean', persist: false },     
    ];
  }

}